import React from "react";
import styles from "./styles.module.scss";

import Reveal from "../../components/CapaV2/Reveal";
import NavV2 from "../../components/CapaV2/NavV2";
import HeroV2 from "../../components/CapaV2/HeroV2";
import SobreV2 from "../../components/CapaV2/SobreV2";
import MarcasV2 from "../../components/CapaV2/MarcasV2";
import ComoFuncionaV2 from "../../components/CapaV2/ComoFuncionaV2";
import BeneficiosV2 from "../../components/CapaV2/BeneficiosV2";
import DepoimentosV2 from "../../components/CapaV2/DepoimentosV2";
import PublicoV2 from "../../components/CapaV2/PublicoV2";
import ComunidadeV2 from "../../components/CapaV2/ComunidadeV2";
import FaqV2 from "../../components/CapaV2/FaqV2";
import AjudaV2 from "../../components/CapaV2/AjudaV2";
import FooterV2 from "../../components/CapaV2/FooterV2";

const SIGNUP_LINK = "/signup/";

const CapaV2: React.FC = () => {
  return (
    <div className={styles.capaV2}>
      <NavV2 signupLink={SIGNUP_LINK} />
      <HeroV2 signupLink={SIGNUP_LINK} />
      <Reveal>
        <SobreV2 />
      </Reveal>
      <Reveal>
        <MarcasV2 signupLink={SIGNUP_LINK} />
      </Reveal>
      <Reveal>
        <ComoFuncionaV2 />
      </Reveal>
      <Reveal>
        <BeneficiosV2 signupLink={SIGNUP_LINK} />
      </Reveal>
      <Reveal>
        <DepoimentosV2 />
      </Reveal>
      <Reveal>
        <PublicoV2 signupLink={SIGNUP_LINK} />
      </Reveal>
      <Reveal>
        <ComunidadeV2 />
      </Reveal>
      <Reveal>
        <FaqV2 />
      </Reveal>
      <Reveal>
        <AjudaV2 />
      </Reveal>
      <FooterV2 />
    </div>
  );
};

export default CapaV2;
